import { render } from "./BusinessCardList.vue?vue&type=template&id=16b698e6"
import script from "./BusinessCardList.vue?vue&type=script&lang=js"
export * from "./BusinessCardList.vue?vue&type=script&lang=js"

import "./BusinessCardList.vue?vue&type=style&index=0&id=16b698e6&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_e6684e1c54ce0e601933c41c13e63276/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__